export enum RequestUpdateTypeEnum {
  REROLLED = 'rerolled',
  AVAILABLE_REQUESTS = 'available-requests',
  ACCEPTED = 'accepted',
  HANDOVER = 'handover',
  CANCELED = 'canceled',
  CANCELED_BY_MOD = 'canceled-by-mod',
  ASK_TO_CANCEL = 'ask-to-cancel',
  MATCHMAKING_CANCELED = 'matchmaking-canceled',
  MATCHMAKING_REROLLED = 'matchmaking-rerolled',
  TIPPING_MESSAGE = 'tipping-message',
  CREATE_BAN = 'create-ban',
}
